import "../Containers/App.css";
import React, { useRef } from "react";
import { Router, Route, Switch } from "react-router-dom";

import Plan from "../Components/PlanReviews/Plans";
import AddPlan from "../Components/AddPlan/AddPlan";
import LoginPage from "../Components/LoginComponents/LoginPage";
import ErrorPage from "../Components/LoginComponents/ErrorPage";
import AuthenticatedRoute from "../Components/LoginComponents/AuthenticatedRoute";
import VerificationLanding from "../Components/VerificationPage/VerificationLanding";

import { Auth } from "aws-amplify";
import FullStory from "react-fullstory";
import awsconfig from "./../aws-exports";
import API_CONFIG from "./../api-config";
import history from "@safecv/shared/history";
import { ToastContainer } from "react-toastify";
import ToastCloseButton from "@safecv/shared/toastClose";

if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) Auth.configure(awsconfig);

const ORG_ID = "TYXXT";

let fullstory;

if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  API_CONFIG.FULL_STORY_ENABLED === true
) {
  fullstory = <FullStory org={ORG_ID} />;
}

function App() {
  const socket = useRef(null);
  return (
    <div className="App">
      {fullstory}
      <Router history={history}>
        <Switch>
          <Route path="/" exact component={LoginPage} socket={socket} />
          <AuthenticatedRoute path="/plans" component={Plan} socket={socket} />
          <AuthenticatedRoute
            path="/plans:filter"
            component={Plan}
            socket={socket}
          />
          <AuthenticatedRoute
            path="/addplans"
            component={AddPlan}
            socket={socket}
          />
          <AuthenticatedRoute
            path="/plan/:jobId/:viewerType"
            component={VerificationLanding}
            socket={socket}
          />
          {/* will make this point to verification page for SOW3 */}
          <AuthenticatedRoute path="/error" component={ErrorPage} />
        </Switch>
      </Router>
      <ToastContainer
        closeButton={<ToastCloseButton className="toast-container" />}
      />
    </div>
  );
}

export default App;
